import { createSelector } from "reselect";

const selectTrain = state => state.train

export const selectDetails = createSelector(
    [selectTrain],
    (train) => train.detailsData
)

export const selectRailyatriId = createSelector(
    [selectTrain],
    (train) => train.railyatriId
)

export const selectUrlData = createSelector(
    [selectTrain],
    (train) => train.urlData
)

export const selectOffset = createSelector(
    [selectTrain],
    (train) => train.offset
)
export const selectType = createSelector(
    [selectTrain],
    (train) => train.type
)
export const selectBugText = createSelector(
    [selectTrain],
    (train) => train.bugText
)
export const selectFeedbackText = createSelector(
    [selectTrain],
    (train) => train.feedbackText
)
export const selectImagesBug = createSelector(
    [selectTrain],
    (train) => train.bugimgs
)
export const selectImagesFeedback = createSelector(
    [selectTrain],
    (train) => train.feedbackimgs
)
export const selectLogged = createSelector(
    [selectTrain],
    (train) => train.loggedIn
)